<script setup>
// import moment from 'moment'
import moment from 'moment-timezone'
import { mediaUrl } from '@core/utils/mediaUrl'
import {useHappeningsStore, useUserGroupsStore, useUsersStore, useRestaurantsStore} from "@/stores"
import {numberWithCommas, simulation, encodeUUID, restaurantUrlSegment} from '@/plugins/misc'
import {ref} from "vue"
import {requiredValidator, urlValidator} from "@validators"
import AppDateTimePicker from "@core/components/AppDateTimePicker.vue"
import {VForm} from "vuetify/components"
import {storeToRefs} from "pinia"
import {useRoute} from "vue-router"

const props = defineProps({
  restaurant: {
    type: Object,
  },
})
const router = useRouter()
const route = useRoute()

const usersStore = useUsersStore()
let myUser = null
let isRunningInStandAlone = null;
({ myUser, isRunningInStandAlone } = storeToRefs(usersStore))

const userGroupsStore = useUserGroupsStore()
let restaurantUserGroups = null;
({ restaurantUserGroups  } = storeToRefs(userGroupsStore))

const restaurantsStore = useRestaurantsStore()
let restaurants = null;
({ restaurants } = storeToRefs(restaurantsStore))

const happeningsStore = useHappeningsStore()
let allHappenings = null;
({ allHappenings } = storeToRefs(happeningsStore))
happeningsStore.getHappenings()
const valid = ref(true)

const editingHappening = ref(null)
const deleteingHappening = ref(null)

const choosingImage = ref(false)

const isConfirmDeleteDialogOpen = ref(false)

//
// const emit = defineEmits(['update:modelValue'])
const loaded = ref({})

function handleLoad(index) {
  loaded.value[index] = true
}

const handleMediaSelection = selectedMedia => {
  // Do something with the selected media
  console.log(selectedMedia)
  if(selectedMedia){
    //rips out any ?t=9287439832749 that may have been added to refresh the image after cropping
    editingHappening.value.imageId = selectedMedia.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/)[0]
  } else{
    editingHappening.value.imageId = null
  }
  choosingImage.value = false
}
const saveHappening = async happening => {
  // Ensure all fields, including imageId, are validated
  const isImageIdValid = imageIdValidator(happening.imageId) === true

  // if(valid.value && isImageIdValid){
  if(valid.value){

    //if happening.url doesn't have an http:// or https:// then add http://
    if(happening.url && !happening.url.match(/^(http|https):\/\//)){
      happening.url = `http://${happening.url}`
    }

    await happeningsStore.saveHappening(happening._id)
    happening.new = undefined
    happening.editing = false
    editingHappening.value = null
  } else if(!isImageIdValid){
    alert("Image required, please add one and save again.")
  }
}
const deleteHappening = happening => {
  console.log(happening)
  happeningsStore.deleteHappening(happening._id)
  deleteingHappening.value = null

}
const newHappening = () => {
  let theHappening = {editing:true, new:true, restaurantName:props.restaurant.name, restaurantMarket:props.restaurant?.market, date: null, endDate: null, url: null, approved: true}
  allHappenings.value.unshift(theHappening)
  editingHappening.value = theHappening
}

const cancelEditingHappening = happening => {
  console.log(happening)
  if(happening.new){
    allHappenings.value = allHappenings.value.filter(e => e != happening)
  } else{
    happeningsStore.getHappenings()

    // happening.editing = false;
    // editingHappening.value = null
  }
  happening.editing = false
  editingHappening.value = null
}

const imageIdValidator = value => {
  if (!value || value.trim() === '') {
    return 'Image is required'
  }
  
  return true
}

const shareLink = link => {
  if (navigator.share) {
    navigator.share({
      // title: 'Check out the restaurant on RM Preferred Reservations',
      // text: "Hey!" + "\n" + "I found this restaurant on RM." + "\n" +
      //     "Members use RM to get preferred times N/A on OpenTable, Resy, etc (i.e. restaurant’s private inventory) & to simplify private/group event bookings with 1 inquiry to 10 preferred places.\n" +
      //     "\n" +
      //     "Check it out:",
      url: link,
    })
      .then(() => console.log('Successful share'))
      .catch(error => console.log('Error sharing', error))
  }
}

const navToRestaurant = (name, market) => {
  //find restaurant in restaurants and get profileId
  const theRestaurant = restaurants.value.find(restaurant => restaurant.name == name && restaurant.market == market)
  if(theRestaurant){
    router.push({path: `/r/${theRestaurant.profileId}`})
  }
}

const getRestaurant = (name, market) => {
  return restaurants.value.find(restaurant => restaurant.name == name && restaurant.market == market)
}

//computed property of happeningsToShow
const happeningsToShow = computed(() => {
  let returnArray = []
  if(props.restaurant?.name && props.restaurant?.market){
    returnArray = allHappenings.value.filter(happening => happening.restaurantName == props.restaurant.name && happening.restaurantMarket == props.restaurant?.market)
  }
  else if(props.restaurant?.market){
    returnArray = allHappenings.value.filter(happening => happening.restaurantMarket == props.restaurant?.market)
  }
  else if(props.restaurant?.name){
    returnArray = allHappenings.value.filter(happening => happening.restaurantName == props.restaurant.name)
  }
  else{
    returnArray = allHappenings.value
  }

  if(route.query.hasOwnProperty('all') || myUser?.value?.userLevel == 'admin' || myPermission.value) return returnArray

  returnArray = returnArray.filter(happening => happening.approved)
  
  return returnArray
})

//computed property of happeningsToShow
const happeningsToShowUpcoming = computed(() => {

  //filter by dates of today or later
  let returnArray = happeningsToShow.value.filter(happening => (moment(happening.date).isSameOrAfter(moment().startOf('day')) || (happening.date == null)))

  //order by date
  returnArray.sort( function(a,b){
    if ( a.date > b.date ){
      return 1
    }
    if ( a.date < b.date ){
      return -1
    }
    
    return 0
  } )
  
  return returnArray

})
const happeningsToShowPast = computed(() => {

  //filter by dates of today or later
  let returnArray = happeningsToShow.value.filter(happening => moment(happening.date).isBefore(moment().startOf('day')))

  //order by date
  returnArray.sort( function(a,b){
    if ( a.date < b.date ){
      return 1
    }
    if ( a.date > b.date ){
      return -1
    }
    
    return 0
  } )
  
  return returnArray
})



//user's permission, if any, for current restaurant
const myPermission = computed(() => {
  //in restaurantUserGroups find a group where the props.restaurant._id matches and then in that groups userPermissions array find obejct that matches for email = myUser.value.email then return the "permission" key value in the same object that matched the email
  if(restaurantUserGroups.value?.length > 0){
    const theGroup = restaurantUserGroups.value.find(group => group?.restaurant?._id == props?.restaurant?._id)
    if(theGroup){
      const thePermission = theGroup.userPermissions.find(permission => permission.email == myUser.value.email)
      if(thePermission){
        return thePermission.permission
      }
    }
  }
})

const webShareApiSupported = computed(() => {
  return navigator.share
})
</script>

<template>
  <div class="happening-grid gap-4">
    <MediaChooserAndManager
      v-if="myUser?.userLevel == 'admin' || myPermission"
      v-model:is-dialog-visible="choosingImage"
      title="Choose an image"
      :preselected-media-ids="[editingHappening?.imageId]"
      crop-stencil="rectangle"
      :crop-aspect-ratio="1080/1350"
      :restaurant="restaurant"
      @media-selected="handleMediaSelection"
    />
    <ConfirmDialog
      v-model:is-dialog-visible="isConfirmDeleteDialogOpen"
      confirmation-msg="Are you sure you want to delete?"
      confirm-btn-text="Yes"
      cancel-btn-text="No"
      @confirm="deleteHappening(deleteingHappening); isConfirmDeleteDialogOpen = false;"
      @cancel=" isConfirmDeleteDialogOpen = false; deleteingHappening = null;"
    />


    <div
      v-if="happeningsToShow?.length == 0 && !(myUser?.userLevel == 'admin' || myPermission)"
      class="ml-4 mr-4 text-xs text-center"
    >
      <div
        v-if="restaurant?.website"
        class="text-xs text-center"
      >
        <a
          :href="restaurant.website"
          target="_blank"
        >view restaurant website</a><br>experiences, special offerings, updates
      </div>
    </div>

    <div
      v-if=" (myUser?.userLevel == 'admin' || myPermission) && restaurant?.name && restaurant?.market && !editingHappening"
      class="text-center"
    >
      <VBtn
        size="small"
        width="fit-content"
        class="profile-header-edit-button"
        variant="text"
        prepend-icon="mdi-plus"
        density="compact"
        @click="newHappening"
      >
        Post Happenings
      </VBtn>
      <div
        v-if="happeningsToShowUpcoming?.length == 0"
        class="text-xs mt-4"
      >
        <b>Examples</b><br>
        (i.e., same shared on Instagram/via email)<br>
        Events/Experiences: Wine dinners,collaborations<br>
        Special Offers: Happy hour, brunch/lunch items<br>
        Updates: New menus, awards
      </div>
      <div
        v-if="happeningsToShowUpcoming?.length == 0"
        class="text-xs mt-2"
      >
        <b>Audience</b><br>
        Members get notifications of Happenings at their Favorites<br>
        Viewable by all here & on home screen
      </div>
    </div>

    <!--      <div v-if="happeningsToShowUpcoming?.length > 0" class="text-center text-sm"><b>Upcoming</b></div> -->
    <div
      v-for="(item, index) in happeningsToShowUpcoming"
      v-if="happeningsToShowUpcoming?.length > 0"
      class="d-flex flex-column h-100 gap-2 mb-3"
    >
      <template v-if="item?.editing">
        <VForm
          v-model="valid"
          validate-on="input blur submit"
          class="edit-happening-card"
          @submit.prevent="saveHappening(item)"
        >
          <div>
            <VTextarea
              v-model="item.name"
              label="Happening Name"
              autocomplete="null"
              density="compact"
              class=""
              rows="1"
              auto-grow
              :rules="[requiredValidator]"
              required
              counter="75"
              maxlength="75"
            />
            <VTextarea
              v-model="item.description"
              label="Description (brief)"
              autocomplete="null"
              density="compact"
              class=""
              rows="1"
              auto-grow
              :rules="[requiredValidator]"
              required
              counter="750"
              maxlength="750"
              hint="(if single date select below, otherwise can share in description for multiple)"
              persistent-hint
            />
            <div class="text-sm mb-2">
              <u>Optional</u>
            </div>
            <AppDateTimePicker
              v-model="item.date"
              label="Date"
              :config="{ disableMobile: true, altInput: true, altFormat: 'l, n/j', dateFormat: 'Y-m-d', maxDate: moment().add(1,'year').format('YYYY-MM-DD')}"
            />

            <!--            <AppDateTimePicker -->
            <!--                v-model="item.endDate" -->
            <!--                label="End Date (if applicable)" -->
            <!--                :config="{ disableMobile: true, altInput: true, altFormat: 'l, n/j', dateFormat: 'Y-m-d', maxDate: moment().add(1,'year').format('YYYY-MM-DD')}" -->
            <!--            /> -->
            <!--            <v-text-field -->
            <!--                v-model="item.price" -->
            <!--                label="Price" -->
            <!--                autocomplete="null" -->
            <!--                class="" -->
            <!--                hint="e.g. '$100 per person'" -->

            <!--            /> -->
            <VTextField
              v-model="item.url"
              label="web link"
              autocomplete="null"
              density="compact"
              class=""
              hint="Direct link to view more or book."
              :rules="[urlValidator]"
            />

            <div class="flex flex-column align-center">
              <div
                class="mb-8 max-content-width"
                @click="choosingImage = !choosingImage"
              >
                <div
                  v-if="item.imageId"
                  class="text-center"
                >
                  <img
                    :src="mediaUrl(item.imageId, 'small')"
                    class="flex-1-0"
                    style="max-height: 300px; object-fit: contain; width: 100%; max-width: 500px; border-radius: 0.2rem;"
                  >
                  <div class="text-sm text-primary cursor-pointer">
                    change image
                  </div>
                </div>
                <div
                  v-else
                  class="avatar-fallback flex flex-row align-center justify-center"
                >
                  <span class="text-sm text-primary cursor-pointer"><VIcon
                    style="margin-left: -3px;"
                    size="22"
                    class="mr-1"
                  >mdi-image</VIcon><b>Add image</b></span>
                </div>
              </div>
            </div>
            <!--            approved checkbox -->
            <VCheckbox
              v-if="myUser?.userLevel == 'admin'"
              v-model="item.approved"
              label="Approved"
              class="text-xs"
            />
          </div>
          <div class="text-center">
            <VBtn
              size="small"
              width="fit-content"
              class="profile-header-edit-button"
              variant="text"
              density="compact"
              v-bind="props"
              type="submit"
            >
              Save
            </VBtn>
            <VBtn
              size="small"
              width="fit-content"
              class="profile-header-edit-button"
              variant="text"
              density="compact"
              v-bind="props"
              @click="cancelEditingHappening(item)"
            >
              Cancel
            </VBtn>
          </div>
        </VForm>
      </template>
      <template v-else>
        <VCard class="happening align-self-center pa-2">
          <div
            class="happening text-center"
            style="width: fit-content;"
          >
            <div class=" mb-1">
              <div
                v-if="!restaurant?.name"
                class="text-xs text-primary cursor-pointer"
                @click="navToRestaurant(restaurant?.name || item.restaurantName, restaurant?.market || item.restaurantMarket)"
              >
                <VIcon style="margin-left: -3px; margin-top: -3px;">
                  iconamoon:certificate-badge-light
                </VIcon>{{ item.restaurantName }} <span v-if="getRestaurant(item.restaurantName, item.restaurantMarket)">{{ getRestaurant(item.restaurantName, item.restaurantMarket).group }}</span>
              </div>
              <div
                v-if="!restaurant?.market"
                class="text-xs"
              >
                {{ item.restaurantMarket.split(',')[0] }}
              </div>
              <div class="text-xs">
                <b>{{ item.name }}</b>
              </div>
              <div
                v-if="item.endDate"
                class="text-xs"
              >
                Dates: {{ moment(item.date).format("dddd, M/D") }} - {{ moment(item.endDate).format("dddd, M/D") }}
              </div>
              <div
                v-else-if="item.date"
                class="text-xs"
              >
                {{ moment(item.date).format("dddd, M/D") }}
              </div>
              <!--                  <div v-if="item.updatedAt" class="text-xs">{{moment(item.updatedAt).fromNow()}}</div> -->
            </div>
            <a
              v-if="item.imageId"
              style="text-decoration: inherit; color: inherit;"
              :href="item.url"
              target="_blank"
            >

              <VImg
                :src="mediaUrl(item.imageId, 'small')"
                class="flex-1-0"
                :style="{ height: loaded[index] ? 'auto' : '500px', width: '100%', objectFit: 'contain', maxWidth: '500px', borderRadius: '0.2rem' }"
                @load="() => handleLoad(index)"
              >
                <!-- Placeholder content -->
                <template #placeholder>
                  <div class="d-flex align-center justify-center fill-height">
                    <VProgressCircular
                      color="grey-lighten-4"
                      indeterminate
                    />
                  </div>
                </template>
              </VImg>
            </a>

            <div class=" mb-1">
              <div
                v-if="item.description"
                class="text-xs"
              >
                {{ item.description }}
              </div>
              <div
                v-if="item.price"
                class="text-xs"
              >
                Price: {{ item.price }}
              </div>
              <div
                v-if="item.url"
                class="mt-0 text-xs text-primary cursor-pointer"
              >
                <a
                  style="text-decoration: inherit; color: inherit;"
                  :href="item.url"
                  target="_blank"
                >
                  View more <VIcon size="x-small">mdi-external-link</VIcon>
                </a>
              </div>
              <!--                  <div v-if="item.updatedAt" class="text-xs">{{moment(item.updatedAt).fromNow()}}</div> -->
            </div>
            <!--                  <div> -->
            <!--                    <v-btn -->
            <!--                      size="small" -->
            <!--                      width="fit-content" -->
            <!--                      class="profile-header-edit-button" -->
            <!--                      variant="text" -->
            <!--                      density="compact" -->
            <!--                      @click="" -->
            <!--                      disabled -->
            <!--                    > -->
            <!--                      <v-icon >mdi-heart-outline</v-icon> -->
            <!--                    </v-btn> -->
            <!--                    <v-btn -->
            <!--                      v-if="item?.url" -->
            <!--                      size="small" -->
            <!--                      width="fit-content" -->
            <!--                      class="profile-header-edit-button" -->
            <!--                      variant="text" -->
            <!--                      density="compact" -->
            <!--                      @click="shareLink(item.url)" -->
            <!--                      :disabled="!webShareApiSupported" -->
            <!--                    > -->
            <!--                      <v-icon>ion-share-outline</v-icon> -->
            <!--                    </v-btn> -->
            <!--                    <v-btn -->
            <!--                      size="small" -->
            <!--                      width="fit-content" -->
            <!--                      class="profile-header-edit-button" -->
            <!--                      variant="text" -->
            <!--                      density="compact" -->
            <!--                      @click="" -->
            <!--                      disabled -->
            <!--                    > -->
            <!--                      <v-icon>mdi-bookmark-outline</v-icon> -->
            <!--                    </v-btn> -->
          </div>
          <div
            v-if="!editingHappening && (myUser?.userLevel == 'admin' || myPermission)"
            class="admin-button-holder"
          >
            <VBtn
              size="small"
              width="fit-content"
              class=""
              variant="text"
              prepend-icon="mdi-edit"
              density="compact"
              v-bind="props"
              @click="item.editing = true; editingHappening = item"
            >
              Edit
            </VBtn>
            <VBtn
              size="small"
              width="fit-content"
              class=""
              variant="text"
              prepend-icon="mdi-delete"
              density="compact"
              v-bind="props"
              @click="isConfirmDeleteDialogOpen = true; deleteingHappening = item"
            >
              Delete
            </VBtn>
          </div>
          <div
            v-if="!item.approved"
            class="text-xs"
            style="position: absolute; bottom: 5px; width: max-content;"
          >
            <i>(pending approval)</i>
          </div>
        </VCard>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.happening {
  max-width: 500px;
}

.happening-grid {
  display: grid;
  //grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  grid-template-columns: repeat(1, 1fr);
}
//@media (max-width: 868px) { /* Adjust 768px based on your breakpoint needs */
//  .happening-grid {
//    /* Ensure 3 items per row on smaller screens */
//    grid-template-columns: repeat(1, 1fr);
//  }
//}

.admin-button-holder {
  float: right;
  //bottom: 4px;
  position: relative;
}

.admin-reservation-menu-button {
  position: relative;
  float: right;
  top: 0;
  right: 0;
}


.avatar {
  cursor: pointer;
  position: relative;
  width: 6rem;
  height: 6rem;
  background: var(--ds-brand-primary-light);
  margin-left: 0.5rem;
}


@media screen and (min-width: 670px) {
  .avatar {
    width: 6rem;
    height: 6rem;
    outline-offset: 0.5rem;
    margin: 1rem 2rem 0;
  }

  .avatar:hover {
    filter: brightness(0.8);
  }
}

.avatar-fallback {
  width: 100%;
  height: 100%;
  font-size: 1.6rem;
}
@media screen and (min-width: 670px) {
  .avatar-fallback {
    font-size: 2rem;
  }
}

.avatar-image {
  width: 100%;
  height: 100%;
}



.avatar-camera-icon {
  width: 1.2rem;
  height: 1.2rem;
  transform: translateY(1px);
}

.avatar-fallback-text {
  width: fit-content;
}

.edit-happening-card{
  margin: 1rem;
  padding: 1rem;
  border: 1px solid var(--ds-border-default);
  border-radius: 0.3rem;
  box-shadow: 0px 0px 6px rgba(0,0,0,0.1);
}


:deep(.smaller-label .v-label){
  font-size: 16px !important;
}

:deep(.v-selection-control__input){
  justify-content: right;
}

:deep(.custom-font-size .v-input__control .v-field__input input ){
  font-size: 16px !important;
}

:deep(.v-field-label ){
  font-size: 16px !important;
}

:deep(.v-select__selection-text){
  font-size: 16px !important;
}
:deep(.smaller-input .v-field__input){
  font-size: 16px !important;
}
</style>
